import {
  DOSWIADCZENIE, FORMY_PRACY, TYPY_ZATRUDNIENIA, WYMIARY_GODZINOWY,
} from '~/modules/storyblok/constants';

export const getTypeOfEmployment = (type) => TYPY_ZATRUDNIENIA[type] || 'Inne';
export const getOfferType = (type) => FORMY_PRACY[type] || 'Inna';
export const getHourlyDimension = (type) => WYMIARY_GODZINOWY[type] || 'Inny';
export const getExperience = (type) => DOSWIADCZENIE[type] || 'Inne';

export interface WorkOffer {
  [index: string]: any;
}
export interface MappedWorkOffer {
  name: string;
  fullSlug: string;
  stanOferty: any;
  lokalizacja: string;
  formaPracy: string;
  doswiadczenie: string;
  typZatrudnienia: string;
  wymiarGodzinowy: string;
}

export const mapOffers = (workOffers: WorkOffer[]): MappedWorkOffer[] => workOffers
  .filter((offer) => offer.content.stan_oferty)
  .map((workOffer) => {
    const {
      content: {
        forma_pracy: formaPracy,
        lokalizacja,
        stan_oferty: stanOferty,
        doswiadczenie,
        typ_zatrudnienia: typZatrudnienia,
        wymiar_godzinowy: wymiarGodzinowy,
      },
      name,
      full_slug: fullSlug,
    } = workOffer;

    return {
      name,
      fullSlug: `/${fullSlug}`,
      stanOferty,
      lokalizacja: lokalizacja || 'Cała Polska',
      formaPracy: formaPracy.map((i) => getOfferType(i)).join(' / '),
      doswiadczenie: doswiadczenie.map((i) => getExperience(i)).join(' / '),
      typZatrudnienia: typZatrudnienia.map((i) => getTypeOfEmployment(i)).join(' / '),
      wymiarGodzinowy: wymiarGodzinowy.map((i) => getHourlyDimension(i)).join(' / '),
    };
  });

export const mapOffer = (workOffer: WorkOffer) => {
  const {
    content: {
      lokalizacja,
      doswiadczenie,
      forma_pracy: formaPracy,
      stan_oferty: stanOferty,
      link_to_offer: linkToOffer,
      typ_zatrudnienia: typZatrudnienia,
      wymiar_godzinowy: wymiarGodzinowy,
    },
    name,
  } = workOffer;

  return {
    name,
    stanOferty,
    lokalizacja: lokalizacja || 'Cała Polska',
    linkToOffer,
    formaPracy: formaPracy.map((i) => getOfferType(i)).join(' / '),
    doswiadczenie: doswiadczenie.map((i) => getExperience(i)).join(' / '),
    typZatrudnienia: typZatrudnienia.map((i) => getTypeOfEmployment(i)).join(' / '),
    wymiarGodzinowy: wymiarGodzinowy.map((i) => getHourlyDimension(i)).join(' / '),
  };
};
